import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import {
  admin_company_details_id,
  update_company_registration,
  user_company_domain_list,
  update_company_registration_superadmin,
} from "../admin.api";
import moment from "moment";
import CommonForm from "../../../components/commonform/commonForm";
import { EmailValidate } from "../../../components/formValidate";
import TextEditer from "../../../components/inputs/texteditor";
import "./style.css";
import jwtDecode from "jwt-decode";
let flag = false;
export default function EditKeralaRequest(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [basicData, setBasicData] = useState({});
  const [keyvalue, setKeyvalue] = useState(0);
  const [domainData, setDomain] = useState([]);
  const [count, setCount] = useState(1);
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const selectedParam = useParams();
  const fileInputRef = useRef(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear + 1}-${startYear + 2}`,
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const getDomainTypes = () => {
    setIsActive(true);
    user_company_domain_list().then((res) => {
      let domData = res?.data;
      // setDomain(res?.data);
      setCount(count + 1);
      getDetails(domData);
      setIsActive(false);
    });
  };
  const handlePhoneNumberChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value.length <= 10) {
      let newValue = value.replace(/[^0-9]/g, "");
      let data = basicData;
      data = {
        ...data,

        [name]: newValue,
      };
      setBasicData(data);
    }
  };
  const handleNumberChange = (e) => {
    let data = { ...basicData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setBasicData(data);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData();

    const appendIfValue = (key, value) => {
      if (value !== null && value !== undefined && String(value).trim() !== "" && String(value).trim() !== "null") {
        form.append(key, value);
      }
    };

    appendIfValue("company_name", basicData?.company_name);
    appendIfValue("phone_number", basicData?.mobile_number);
    form.append("company_type", "kerala");
    appendIfValue("person_name", basicData?.person_name);
    appendIfValue("person_designation", basicData?.person_designation);
    appendIfValue("address", basicData?.address);
    appendIfValue("email", basicData?.email);
    appendIfValue("alternate_email", basicData?.alternate_email);
    appendIfValue("logo", basicData?.logo);

    if (basicData?.country_code && basicData?.alternate_phone) {
      appendIfValue("country_code", basicData?.country_code);
    }
    appendIfValue("alternate_phone", basicData?.alternate_phone);
    appendIfValue("abstract_project_proposal", basicData?.abstract_project_proposal);
    appendIfValue("upload_proposal", basicData?.upload_proposal);
    appendIfValue("capital_investment", basicData?.capital_investment);
    appendIfValue("ex_man_power", basicData?.ex_man_power);
    appendIfValue("site_link", basicData?.site_link);
    appendIfValue("cin_number", basicData?.cin_number);

    // Append financial records as array with employment details
    (basicData.financial_records || []).forEach((record, index) => {
      if (record.financial_year) {
        appendIfValue(`financial_records[${index}][financial_year]`, record.financial_year);
        appendIfValue(`financial_records[${index}][fy_turnover]`, record.fy_turnover);
        appendIfValue(`financial_records[${index}][capital_investment]`, record.capital_investment);
        appendIfValue(`financial_records[${index}][remarks]`, record.remarks);
        appendIfValue(`financial_records[${index}][dir_employ_male]`, record.dir_employ_male);
        appendIfValue(`financial_records[${index}][dir_employ_female]`, record.dir_employ_female);
        appendIfValue(`financial_records[${index}][dir_employ_others]`, record.dir_employ_others);
        appendIfValue(`financial_records[${index}][dir_employ_sc_st]`, record.dir_employ_sc_st);
        appendIfValue(`financial_records[${index}][dir_employ_pwd]`, record.dir_employ_pwd);
        appendIfValue(`financial_records[${index}][direct_emp]`, record.direct_emp);
      }
    });

    appendIfValue("achievements", basicData?.achievements);
    appendIfValue("fe_component", basicData?.fe_component);

    if (basicData?.certification === "Other") {
      appendIfValue("certification", basicData?.otherCertification);
    } else {
      appendIfValue("certification", basicData?.certification);
    }

    form.append("any_other_flag", basicData?.any_other_flag == true ? "1" : "0");
    if (basicData?.any_other_flag == true) {
      appendIfValue("any_other_domain", basicData?.any_other_domain);
    }

    appendIfValue("file_name", basicData?.file_name);
    if (basicData?.id) form.append("application_id", basicData?.id);

    basicData?.product_profiles.forEach((item, index) => {
      if (item.product_name) {
        appendIfValue(`product_profiles[${index}][product_name]`, item.product_name);
        appendIfValue(`product_profiles[${index}][product_desc]`, item.product_desc);
      }
    });

    domainData.forEach((item, index) => {
      if (item.checked) {
        appendIfValue(`domain_types[${index}][domain_name]`, item.domain_name);
        appendIfValue(`domain_types[${index}][id]`, item.id);
      }
    });


    setIsActive(true);
    (adminType === 1
      ? update_company_registration(selectedParam.id, form)
      : update_company_registration_superadmin(selectedParam.id, form)
    )
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  useEffect(() => {
    getDomainTypes();
  }, []);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      setActiveStep(0);
      setBasicData({});

      setDomain([]);
      props.history.push("/kerala-companies-list");
    }
  };

  const getDetails = (domData) => {
    let otherDom = [];
    admin_company_details_id(selectedParam.id).then((res) => {
      let Data = res?.data;
      otherDom = Data?.domain_types?.filter(
        (ar1) => !domData.some((ar2) => ar1?.domain_name === ar2?.domain_name)
      );

      domData?.forEach((item) => {
        item["checked"] = Data?.domain_types?.some(
          (dom) => item?.domain_name === dom?.domain_name
        );
      });
      setDomain(domData);
      let d = {
        ...Data,
        any_other_flag:
          Data.any_other_flag && Data.any_other_flag !== "0" ? true : false,
        any_other_domain:
          Data.any_other_domain && Data.any_other_flag !== "0"
            ? Data.any_other_domain
            : "",
        country_code:
          Data.country_code === "null" || Data.country_code === "undefined"
            ? ""
            : Data.country_code,
      };
      setBasicData((prevData) => ({
        ...prevData,
        ...d,
        mobile_number: Data.phone_no,
        file_name: Data?.upload_proposal,
        product_profiles: Data?.product_profiles,
        financial_records: Array.isArray(Data?.financial_records) && Data.financial_records.length > 0
          ? Data.financial_records
          : [{
            financial_year: "",
            fy_turnover: "",
            capital_investment: "",
            remarks: "",
            dir_employ_male: "",
            dir_employ_female: "",
            dir_employ_others: "",
            dir_employ_sc_st: "",
            dir_employ_pwd: "",
            direct_emp: ""
          }],
      }));
      setCount(count + 1);
    });
    setIsActive(false);
  };

  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = basicData;
    data[name] = value;
    setBasicData(data);
    setKeyvalue(keyvalue + 1);
  };
  const addNewProductProfile = (i) => {
    let data = { ...basicData };

    data.product_profiles.push({ product_name: "", product_desc: "" });
    setBasicData(data);
    setCount(count + 1);
  };
  const RemoveProduct = (i) => {
    let data = { ...basicData };
    data.product_profiles.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleMultiChange = (e, i) => {
    let data = { ...basicData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],
      [e.target.name]: e.target.value,
    };

    setBasicData(data);
    setCount(count + 1);
  };
  const handleProductDesc = (val, i) => {
    let data = { ...basicData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],

      product_desc: val,
    };

    setBasicData(data);
    setCount(count + 1);
  };

  const handleCheckChange = (e, item) => {
    flag = false;
    let data = [...domainData];

    data[item]["checked"] = e.target.checked;
    if (domainData) {
      domainData.forEach((item) => {
        if (item.checked) flag = true;
      });
    }
    setCount(count + 1);
    setDomain(data);
  };
  const handleValid = () => {
    let flags = false;
    if (domainData) {
      domainData.forEach((item) => {
        if (item.checked) flags = true;
      });
    }
    return flags;
  };
  const handleOtherChange = (e) => {
    setBasicData({ ...basicData, [e.target.name]: e.target.checked });
  };
  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "pdf" ||
      type?.toLowerCase() === "doc" ||
      type?.toLowerCase() === "docx"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        setBasicData({
          ...basicData,
          file_name: e.target.files[0].name,
          [e.target.name]: e.target.files[0],
        });
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setBasicData({
          ...basicData,
          file_name: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .doc / .docx / .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      setBasicData({
        ...basicData,
        file_name: null,
        [e.target.name]: null,
      });
    }
  };
  const handleOtherCertificationChange = (e) => {
    const { name, value } = e.target;
    setBasicData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const maxMB = 1;
    const fileSizeMB = size / (1024 * 1024);

    const isValidType = ["jpg", "jpeg", "png"].includes(type);

    if (!isValidType) {
      showError("File should be in .png / .jpeg / .jpg format");
      resetFileInput();
      return;
    }

    if (fileSizeMB > maxMB) {
      showError("File size is greater than 1MB");
      resetFileInput();
      return;
    }

    setBasicData({
      ...basicData,
      file_name_photo: file.name,
      [e.target.name]: file,
    });
  };
  const showError = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    setBasicData((prev) => ({
      ...prev,
      file_name_photo: null,
      logo: null,
    }));

    setFileInputKey(Date.now());
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setBasicData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Financial records helpers
  const addFinancialRecord = () => {
    setBasicData((prev) => {
      const list = Array.isArray(prev.financial_records) ? prev.financial_records : [];
      if (list.length >= 3) {
        showError("Maximum 3 financial records allowed");
        return prev;
      }
      return {
        ...prev,
        financial_records: [...list, {
          financial_year: "",
          fy_turnover: "",
          capital_investment: "",
          remarks: "",
          dir_employ_male: "",
          dir_employ_female: "",
          dir_employ_others: "",
          dir_employ_sc_st: "",
          dir_employ_pwd: "",
          direct_emp: ""
        }],
      };
    });
  };

  const removeFinancialRecord = (idx) => {
    setBasicData((prev) => {
      const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
      list.splice(idx, 1);
      return { ...prev, financial_records: list };
    });
  };

  const handleFinancialRecordChange = (idx, field, value) => {
    setBasicData((prev) => {
      const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
      if (["fy_turnover", "capital_investment", "dir_employ_male", "dir_employ_female", "dir_employ_others", "dir_employ_sc_st", "dir_employ_pwd", "direct_emp"].includes(field)) {
        // Remove non-numeric characters except decimal point
        value = value.replace(/[^0-9.]/g, "").slice(0, 13);
      }
      list[idx] = { ...list[idx], [field]: value };
      return { ...prev, financial_records: list };
    });
  };

  return (
    <>
      <Loader open={isActive} />
      <div className="add-per">
        <div className="view-container">
          <form onSubmit={handleSubmit}>
            <h6>
              <b>Update Companies in Kerala</b>
            </h6>
            <hr />
            <div className="row">
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Company Name"
                  required
                  name="company_name"
                  // disabled
                  value={basicData?.company_name ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Contact Person Name"
                  required
                  disabled
                  name="person_name"
                  value={basicData?.person_name ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Contact Person Designation"
                  required
                  // disabled
                  name="person_designation"
                  value={basicData?.person_designation ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="multiline"
                  label="Address"
                  required
                  name="address"
                  value={basicData?.address ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="email"
                  label="Email"
                  error={error.email}
                  required
                  disabled
                  name="email"
                  value={basicData?.email ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Website Link"
                  name="site_link"
                  value={basicData?.site_link ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Phone Number"
                  maxLength="10"
                  minLength="10"
                  pattern="[0-9]{10}"
                  value={basicData?.mobile_number}
                  disabled
                  required
                  onChange={(e) => {
                    handlePhoneNumberChange(e);
                  }}
                  name="mobile_number"
                  {...props}
                />
              </div>
              <div className="col-8 mb-2">
                <label className="control-label mylabel mb-2">
                  Alternate Phone
                </label>

                <div className="d-flex align-items-end w-100">
                  <div className="">
                    <CommonForm
                      fieldType="text"
                      error={error.country_code}
                      name="country_code"
                      maxLength="4"
                      value={basicData?.country_code ?? ""}
                      // disabled
                      onChange={(e) => {
                        handleNumberChange(e);
                      }}
                      {...props}
                    />
                  </div>
                  <div className="p-1"></div>
                  <div className="col-10">
                    <CommonForm
                      fieldType="text"
                      error={error.alternate_phone}
                      name="alternate_phone"
                      maxLength="10"
                      value={basicData?.alternate_phone ?? ""}
                      // disabled
                      onChange={(e) => {
                        handleNumberChange(e);
                      }}
                      {...props}
                    />
                  </div>
                </div>
              </div>
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="email"
                  label="Alternative Email"
                  error={error.alternate_email}
                  name="alternate_email"
                  // disabled
                  value={
                    basicData?.alternate_email &&
                      basicData?.alternate_email !== "null"
                      ? basicData?.alternate_email
                      : ""
                  }
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2 mt-2">
                <CommonForm
                  fieldType="multiline"
                  label="Abstract Project Proposal"
                  required
                  name="abstract_project_proposal"
                  value={basicData?.abstract_project_proposal ?? ""}
                  // disabled
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>
            </div>

            <div className="col-8">
              <CommonForm
                key={fileInputKey}
                ref={fileInputRef}
                fieldType="file"
                // required={!basicData?.logo}
                name="logo"
                {...props}
                label="Logo"
                id="logo"
                fileName={
                  basicData?.file_name_photo
                    ? basicData?.file_name_photo
                    : basicData?.logo
                }
                accept=".jpg,.jpeg,.png"
                type="file"
                variant="outlined"
                onChange={handlePhotoFileChange}
              />
              <small className="pers">
                *Upload only .jpg , .jpeg , .png format and Size should be less
                than 1MB
              </small>
            </div>

            <div className="col-8 mb-2">
              <div>
                {basicData?.product_profiles?.map((e, i) => (
                  <div className="section-datas-cont" key={i}>
                    <div className="header-label">Product Profile</div>

                    <div className="section-Cont">
                      <CommonForm
                        fieldType="text"
                        label="Product Name"
                        required
                        name="product_name"
                        value={e?.product_name}
                        // disabled
                        onChange={(e) => {
                          handleMultiChange(e, i);
                        }}
                        {...props}
                      />
                      <TextEditer
                        label="Product Description (Required)"
                        required
                        name="product_desc"
                        value={e?.product_desc}
                        // disabled
                        keyValue={i}
                        onChange={handleProductDesc}
                        {...props}
                      />
                    </div>

                    <div className="more-btn-cnt">
                      {basicData?.product_profiles.length === i + 1 && (
                        <button
                          style={{ marginLeft: 5 }}
                          type="button"
                          {...props}
                          className="btn btn-primary"
                          onClick={(e) => addNewProductProfile(i)}
                        >
                          Add More
                        </button>
                      )}
                      {basicData?.product_profiles.length > 1 && (
                        <button
                          {...props}
                          type="button"
                          className="btn btn-primary"
                          onClick={(e) => RemoveProduct(i)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-8 mb-2">
              <div>
                <div className="header-label">Domain Type</div>
                <div className="check-box-cont">
                  {domainData &&
                    domainData.map((item, index) => (
                      <CommonForm
                        fieldType="checkbox"
                        value={item.checked}
                        required={!basicData?.any_other_flag && !handleValid()}
                        checked={item.checked}
                        // disabled
                        onChange={(e) => handleCheckChange(e, index)}
                        label={item.domain_name}
                        {...props}
                      />
                    ))}

                  <CommonForm
                    fieldType="checkbox"
                    onChange={handleOtherChange}
                    label="Any Other"
                    name="any_other_flag"
                    // disabled
                    checked={basicData?.any_other_flag}
                    value={basicData?.any_other_flag}
                    {...props}
                  />
                </div>

                {basicData?.any_other_flag &&
                  basicData?.any_other_flag !== "0" && (
                    <div>
                      <CommonForm
                        fieldType="text"
                        placeholder="Please specify the Domain.."
                        required
                        // disabled
                        name="any_other_domain"
                        value={basicData?.any_other_domain ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>
                  )}
              </div>
            </div>

            <div className="col-8 mb-2">
              <div>
                <CommonForm
                  fieldType="file"
                  required={!basicData?.file_name ? true : false}
                  name="upload_proposal"
                  {...props}
                  label="Upload Proposal"
                  id="upload_proposal"
                  // disabled
                  fileName={basicData?.file_name}
                  accept=".pdf,.docx,.doc"
                  type="file"
                  variant="outlined"
                  onChange={handleFileChange}
                />

                <div className="file-up-helper">
                  *Upload only .pdf , .doc, .docx and Size should be less than
                  5MB
                </div>
              </div>
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="Achievements,if any "
                // required
                // maxLength={4}
                name="achievements"
                // disabled
                value={
                  basicData?.achievements && basicData?.achievements !== "null"
                    ? basicData?.achievements
                    : ""
                }
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>

            {/* <div className="col-8 mb-2">
              <CommonForm
                fieldType="number"
                label="Capital Investment Expected so far in Lakhs"
                required
                name="capital_investment"
                value={basicData?.capital_investment ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div> */}
            {/* Financial Records Section */}
            <div className="col-8 mb-2">
              <label className="control-label mylabel mb-2">Financial Records</label>
              {(basicData.financial_records || []).map((rec, idx) => {
                // Build year options excluding years selected in other records
                const selectedYears = (basicData.financial_records || [])
                  .map((r, i) => (i === idx ? null : r.financial_year))
                  .filter(Boolean);
                const availableYears = financialYears.filter((y) => !selectedYears.includes(y));
                return (
                  <div
                    key={`fr-${idx}`}
                    className="section-datas-cont mb-4"
                    style={{
                      border: '2px solid #e0e0e0',
                      borderRadius: '8px',
                      padding: '20px',
                      backgroundColor: '#f9f9f9',
                      // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    <h5 style={{
                      color: '#2c3e50',
                      marginBottom: '15px',
                      paddingBottom: '10px',
                      borderBottom: '2px solid #3498db',
                      fontWeight: '600'
                    }}>
                      Financial Year {rec.financial_year || `Record ${idx + 1}`}
                    </h5>
                    <div className="row">
                      <div className="col-6">
                        <label className="control-label mylabel mb-2">Financial Year</label>
                        <select
                          className="form-select mandatory-select mb-2"
                          aria-label="Select Financial Year"
                          required
                          value={rec.financial_year || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "financial_year", e.target.value)
                          }
                        >
                          <option value="">Select Financial Year</option>
                          {availableYears.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Turnover (in Crores)"
                          value={rec.fy_turnover || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "fy_turnover", e.target.value)
                          }
                          {...props}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Capital Investment for the FY (in Crores)"
                          value={rec.capital_investment || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "capital_investment", e.target.value)
                          }
                          {...props}
                        />
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Remarks (optional)"
                          value={rec.remarks || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "remarks", e.target.value)
                          }
                          {...props}
                        />
                      </div>

                      {/* Employment Details for this Financial Year */}
                      <div className="col-12 mt-3">
                        <h6 style={{ color: '#34495e', marginBottom: '10px', fontWeight: '600' }}>
                          Employment Details for {rec.financial_year || 'this Financial Year'}
                        </h6>
                        <hr style={{ margin: '10px 0 15px 0' }} />

                        <div className="row">
                          <div className="col-md-4">
                            <CommonForm
                              fieldType="text"
                              label="Male"
                              required
                              name="dir_employ_male"
                              value={rec.dir_employ_male ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(idx, "dir_employ_male", e.target.value);
                              }}
                              {...props}
                            />
                          </div>
                          <div className="col-md-4">
                            <CommonForm
                              fieldType="text"
                              label="Female"
                              required
                              name="dir_employ_female"
                              value={rec.dir_employ_female ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(idx, "dir_employ_female", e.target.value);
                              }}
                              {...props}
                            />
                          </div>
                          <div className="col-md-4">
                            <CommonForm
                              fieldType="text"
                              label="Genderqueer"
                              required
                              name="dir_employ_others"
                              value={rec.dir_employ_others ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(idx, "dir_employ_others", e.target.value);
                              }}
                              {...props}
                            />
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-md-4">
                            <CommonForm
                              fieldType="text"
                              label="SC/ST Employees Count"
                              required
                              name="dir_employ_sc_st"
                              value={rec.dir_employ_sc_st ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(idx, "dir_employ_sc_st", e.target.value);
                              }}
                              {...props}
                            />
                          </div>
                          <div className="col-md-4">
                            <CommonForm
                              fieldType="text"
                              label="PWD Employees Count"
                              required
                              name="dir_employ_pwd"
                              value={rec.dir_employ_pwd ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(idx, "dir_employ_pwd", e.target.value);
                              }}
                              {...props}
                            />
                          </div>
                          <div className="col-md-4">
                            <CommonForm
                              fieldType="text"
                              label="Total Direct Employment"
                              required
                              name="direct_emp"
                              value={rec.direct_emp ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(idx, "direct_emp", e.target.value);
                              }}
                              disabled
                              {...props}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {(basicData.financial_records || []).length > 1 && (
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm mt-2"
                        onClick={() => removeFinancialRecord(idx)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                );
              })}
              {((basicData.financial_records || []).length < 3) && (
                <button
                  type="button"
                  className="btn btn-primary btn-sm mt-2"
                  onClick={addFinancialRecord}
                >
                  Add Previous
                </button>
              )}
            </div>
            {/* <div className="col-8 mb-2">
              <CommonForm
                fieldType="number"
                label=" Expected Direct employment as on Date"
                required
                name="ex_man_power"
                value={basicData?.ex_man_power ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div> */}
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="number"
                label="Foreign Exchange (FE) Component"
                // required
                // maxLength={4}
                name="fe_component"
                // disabled
                value={basicData?.fe_component ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            {/* <div className="col-8 mb-2">
              <div className="my-4 mylabel ">Direct Employment Split up</div>
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="Male"
                required
                // maxLength={4}
                name="dir_employ_male"
                value={basicData?.dir_employ_male ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="Female"
                required
                // maxLength={4}
                name="dir_employ_female"
                value={basicData?.dir_employ_female ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="Genderqueer"
                required
                // maxLength={4}
                name="dir_employ_others"
                value={basicData?.dir_employ_others ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="SC/ST"
                required
                // maxLength={4}
                name="dir_employ_sc_st"
                value={basicData?.dir_employ_sc_st ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
 */}
            {basicData?.certification === "KS9100" ||
              basicData?.certification === "ISO9000/2050" ||
              basicData?.certification === "Z_Certfication" ? (
              <div className="col-8 mb-2">
                <div className="mb-2 mylabel">Certifications</div>
                <select
                  className="form-select selectbox "
                  required
                  style={{ lineHeight: "25px !important" }}
                  name="certification"
                  value={basicData?.certification ?? ""}
                  // disabled
                  aria-label="Default select example"
                  onChange={(e) => handleOtherCertificationChange(e)}
                >
                  <option value="">Select</option>
                  <option value="KS9100">KS9100</option>
                  <option value="ISO9000/2050">ISO9000/2050</option>
                  <option value="Z_Certfication">Z Certification</option>
                  <option value="Other">Other</option>
                </select>

                {basicData?.certification === "Other" && (
                  <div className="col-12 my-2">
                    <label htmlFor="otherCertification">
                      Other Certification
                    </label>
                    <input
                      type="text"
                      className="form-control my-2"
                      style={{ borderLeft: "2px solid #ee7e7e" }}
                      id="otherCertification"
                      name="otherCertification"
                      value={basicData?.otherCertification ?? ""}
                      onChange={handleOtherCertificationChange}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="col-8 mb-2">
                <div className="mb-2 mylabel">Certifications</div>
                <select
                  className="form-select selectbox"
                  style={{ lineHeight: "25px!important", borderLeft: "none !important" }}
                  name="certification"
                  value={
                    basicData?.certification &&
                      (basicData?.certification === "KS9100" ||
                        basicData?.certification === "ISO9000/2050" ||
                        basicData?.certification === "Z_Certfication")
                      ? basicData?.certification
                      : "Other"
                  }
                  aria-label="Default select example"
                  onChange={(e) => handleOtherCertificationChange(e)}
                >
                  <option value="">Select</option>
                  <option value="KS9100">KS9100</option>
                  <option value="ISO9000/2050">ISO9000/2050</option>
                  <option value="Z_Certfication">Z Certification</option>
                  <option value="Other">Other</option>
                </select>

                <div className="col-12 my-2">
                  <label htmlFor="otherCertification">
                    Other Certification
                  </label>
                  <input
                    type="text"
                    className="form-control my-2"
                    style={{ borderLeft: "2px solid #ee7e7e" }}
                    id="otherCertification"
                    name="otherCertification"
                    value={
                      basicData?.otherCertification ??
                      basicData?.certification ??
                      ""
                    }
                    onChange={handleOtherCertificationChange}
                  />
                </div>
              </div>
            )}

            <div className="mt-4">
              <div className="col-8 mb-2">
                <center>
                  <button type="submit" className="primary-btn basic-submit">
                    SUBMIT
                  </button>
                </center>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </>
  );
}
